<template>
    <div class="row-detail-data">
        <div v-if="idealMonthsLabel" class="user-data-item">
            <span class="icon material-symbols-outlined">calendar_month</span>
            <div>
                <span class="title">Best in</span>
                <div class="user-input">{{ idealMonthsLabel }}</div>
            </div>
        </div>
        <div v-if="entity.ideal_duration" class="user-data-item">
            <span class="icon material-symbols-outlined">schedule</span>
            <div>
                <span class="title">Ideal duration</span>
                <div class="user-input">~{{ entity.ideal_duration }} days</div>
            </div>
        </div>
        <div v-if="locations.length" class="user-data-item full-width">
            <span class="icon material-symbols-outlined">location_on</span>
            <div>
                <span class="title">Locations</span>
                <div class="user-input">{{ locations.join(" • ") }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RowInfoIdea",
    props: {
        row: {
            type: Object,
            required: true,
        },
        entity: {
            type: Object,
            required: true,
        },
        currency: {
            type: String,
            default: "$",
        },
    },
    computed: {
        idealMonthsLabel() {
            return (this.entity.ideal_months ?? []).join(", ");
        },
        locations() {
            return this.entity.locations ?? [];
        },
    },
};
</script>
